// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/image/icon/check.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-box {
  padding-top: 75.25px;
  padding-left: 20vw;
  margin-left: 10px;
}

.search-bg-box {
  padding-top: 15px;
}

.search-full-box {
  /* height: calc(100vh - 98px); */
  /* overflow-y: auto; */
  /* padding: 15px 24px; */
  padding: 0 24px 15px 24px;
}

.search-sticky-title-box {
  padding: 0 24px 15px 24px;
}

.search-change-box {
  height: calc(100vh - 98px);
  overflow-y: auto;
  padding: 15px 24px;
}

.search-title-icon {
  width: 36px;
  height: 36px;
  margin-right: 8px;
}

.search-title {
  font-size: 27.5px;
}

.search-container {
  /* height: calc(100vh - 113px); */
  height: calc((var(--vh, 1vh) * 100) - 113px);
  overflow-y: auto;
}

.search-title-box {
  background-color: #f2f2f2;
  min-width: 110px;
  border-bottom: 1px solid #fff;
  border-right: 6px solid #fff;
  /* padding: 13px 11px; */
  padding: 0.25rem 11px;
}

.search-sub-bottom-border {
  border-bottom: 1px solid #fff;
  /* padding-right: 11px; */
  min-height: 38px;
}

.search-reset-text {
  text-align: center;
}

.sub-title {
  font-size: 13px;
  margin-left: 10px;
}

.sub-title.hover-help:hover {
  cursor: help;
}

.sfs-9px {
  font-size: 9px;
}

.search-sub-title-box {
  min-width: 110px;
  border-right: 6px solid #fff;
  background-color: #f2f2f2;
  padding-left: 11px;
  padding-right: 11px;
}

.search-content-box {
  background-color: #f2f2f2;
  padding-right: 8px;
  padding-left: 8px;
  padding: 0.5rem 8px;
  /* border-bottom: 1px solid #fff; */
}

.search-content-border-box {
  border-bottom: 1px solid #fff;
}

.search-input {
  outline: none;
  max-width: 489px;
  width: 489px;
  height: 32px;
}

.search-check-label {
  background-color: #fff;
  width: 13px;
  height: 13px;
}

.search-checkbox:checked + .search-check-label {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) #fff no-repeat center / contain;
}

.search-btn {
  background-color: #971b4d;
  width: 157px;
  height: 38px;
  border-radius: 5px;
  text-align: center;
  font-size: 17px;
  line-height: 38px;
}

.search-flex-box {
  display: flex;
  align-items: stretch;
  overflow-x: hidden;
}

.search-title-text {
  text-align: center;
  font-size: 16px;
}

.search-input-text {
  font-size: 16px;
}

.search-input-text::placeholder {
  color: #ababab;
}

.result-container {
  padding-bottom: 1px;
  /* margin-top: 44px; */
}

.result-content {
  background-color: #f2f2f2;
  /* height: 96px; */
  padding: 10px 6.5px 10px 8.5px;
}

.result-title-text {
  font-size: 17.5px;
}

.result-title-flex {
  /* margin-bottom: 8px; */
}

.result-sub-text {
  font-size: 10px;
}

.result-sub-type-text {
  margin-bottom: 13px;
}

.result-sub-type2-text {
  margin-bottom: 2px;
}

.result-price-text {
  font-size: 15px;
  /* margin-top: 5px; */
}

.result-box:hover .result-content {
  background-color: #fff2e9;
}

.result-img {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.result-box:hover .result-img img {
  width: 110%;
  height: 110%;
}

.result-img img {
  transition: all 0.5s ease-in-out;
}

.result-img {
  aspect-ratio: 5 / 3;
  /* height: 191px; */
  background-color: rgb(164, 164, 164);
}

.result-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.result-icon {
  width: 28px;
  height: 28px;
}

.search-title-content {
  margin-bottom: 20px;
}

.search-result-category {
  padding-bottom: 19px;
}

.search-item2-title {
  font-size: 22.5px;
  padding-bottom: 5px;
}

.search-item3-title {
  font-size: 19px;
  padding-bottom: 3px;
}

.sticky-title {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 888;
  padding-top: 11px;
}

.sticky-item2 {
  position: sticky;
  top: 70.25px;
  background-color: #fff;
  z-index: 887;
}

.sticky-item3 {
  position: sticky;
  top: 108px;
  background-color: #fff;
  z-index: 886;
}

.sticky-item4 {
  position: sticky;
  top: 138.5px;
  background-color: #fff;
  z-index: 885;
  padding-bottom: 5px;
}

.no-search {
  margin-top: 44px;
  text-align: center;
}

.result-price-flex-box {
  align-items: center;
}

.search-favor-title {
  border-bottom: 0;
}

.search-last-border,
.search-last-content-border {
  border-bottom: 0;
}

.search-favor-box {
  border-top: 4px solid #fff;
}

.pop-container {
  /* position: relative; */
}

.search-pop {
  position: absolute;
  z-index: 889;
  padding: 15px 12px;
  background-color: #fff;
  border: 1px solid #971b4d;
  max-width: 250px;
}

.pop-title {
  font-size: 11px;
  color: #282828;
  font-weight: 700;
}

.pop-box {
  margin-top: 8px;
  gap: 0 8px;
}

.pop-box-img {
  width: 100%;
  /* height: 73px; */
}

.pop-content {
  font-size: 9px;
  color: #787878;
  white-space: pre-wrap;
  margin-top: 8px;
}

.search-label-width {
  width: 130px;
}

@media (max-width: 1478px) {
  .search-label-width {
    width: 105px;
  }

  .search-label-width .sub-title {
    font-size: 11px;
  }
}

@media (max-width: 1300px) {
  .search-box {
    padding-left: 0;
    margin-left: 0;
    background-color: #fff;
  }

  .search-bg-box {
    /* padding-bottom: 120px; */
  }

  .search-container {
    width: 100%;
  }

  .search-flex-box {
    display: flex;
    flex-direction: column;
  }

  .search-title-box {
    padding-right: 16px;
    padding-left: 16px;
  }

  .search-favor-title {
    border-bottom: 1px solid white;
  }

  .search-title-box,
  .search-sub-title-box {
    width: 100%;
    border-right: 0;
  }

  .search-sub-title-box {
    padding-left: 16px;
    padding-right: 16px;
  }

  .search-content-box {
    flex-wrap: wrap;
    padding-right: 16px;
    padding-left: 16px;
  }

  .search-title-text {
    text-align: start;
    /* margin-left: 1rem; */
  }

  .search-name-text {
    margin-left: 0;
  }

  .result-container {
    /* padding-bottom: 150px; */
  }

  .search-last-border {
    border-bottom: 1px solid #fff;
  }
}

@media (max-width: 768px) {
  .pop-title {
    font-size: 12px;
  }

  .search-reset-text {
    text-align: start;
    padding-left: 0px;
    padding-right: 0px;
  }

  .search-bg-box {
    padding-top: 0;
  }

  .result-price-flex-box {
    align-items: end;
  }

  .result-sub-type2-text {
    margin-bottom: 0;
  }

  .search-input-text {
    font-size: 14px;
  }

  .search-input {
    width: 100%;
    max-width: initial;
  }

  .result-box:nth-child(even) {
    padding-left: 2.5px;
  }

  .result-box:nth-child(odd) {
    padding-right: 2.5px;
  }

  .sticky-title {
    padding-top: 13px;
  }

  .sticky-item2 {
    top: 48.5px;
  }

  .sticky-item3 {
    top: 69px;
  }

  .sticky-item4 {
    top: 91.5px;
  }

  .search-container {
    height: calc(100vh - 163.09px);
    overflow-y: auto;
  }

  .search-box {
    padding-top: 10px;
  }

  .search-full-box {
    padding: 17px 12px 17px 13px;
  }

  .search-sticky-title-box {
    padding: 12px 12px 8px 13px;
  }

  .search-title {
    font-size: 19.753px;
  }

  .search-title-icon {
    width: 25px;
    height: 25px;
    margin-right: 5px;
  }

  .search-title-content {
    margin-bottom: 15px;
  }

  .search-title-text {
    font-size: 14px;
  }

  .sub-title {
    font-size: 10px;
    margin-left: 5px;
  }

  .search-btn {
    font-size: 15px;
  }

  .search-result-category {
    padding-bottom: 7px;
  }

  .search-item2-title {
    font-size: 11.358px;
    padding-bottom: 5px;
  }

  .search-item3-title {
    font-size: 11.358px;
    padding-bottom: 6px;
  }

  .result-img {
    /* height: 101px; */
  }

  .result-content {
    padding: 6px 5px 5px 5px;
    height: auto;
  }

  .result-title-text {
    font-size: 13px;
  }

  .result-title-flex {
    margin-bottom: 0;
  }

  .result-sub-text {
    font-size: 8px;
  }

  .result-sub-type-text {
    margin-bottom: 0;
  }

  .result-price-text {
    font-size: 10px;
    margin-top: 0;
  }

  .result-icon {
    width: 20px;
    height: 20px;
  }

  .search-label-width {
    width: 95px;
  }

  .search-sub-bottom-border {
    min-height: auto;
    padding-top: 10px;
  }

  .search-title-box {
    padding-bottom: 0;
    padding-top: 1rem;
  }

  .search-content-box {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .result-price-mobile-text {
    font-size: 13px;
  }
}

@media (max-width: 1280px) {
  .search-container {
    height: calc(100vh - 129.09px);
  }
}

body {
  -ms-overflow-style: none;
}

body::-webkit-scrollbar {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/search/search.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mFAAqF;AACvF;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf","sourcesContent":[".search-box {\n  padding-top: 75.25px;\n  padding-left: 20vw;\n  margin-left: 10px;\n}\n\n.search-bg-box {\n  padding-top: 15px;\n}\n\n.search-full-box {\n  /* height: calc(100vh - 98px); */\n  /* overflow-y: auto; */\n  /* padding: 15px 24px; */\n  padding: 0 24px 15px 24px;\n}\n\n.search-sticky-title-box {\n  padding: 0 24px 15px 24px;\n}\n\n.search-change-box {\n  height: calc(100vh - 98px);\n  overflow-y: auto;\n  padding: 15px 24px;\n}\n\n.search-title-icon {\n  width: 36px;\n  height: 36px;\n  margin-right: 8px;\n}\n\n.search-title {\n  font-size: 27.5px;\n}\n\n.search-container {\n  /* height: calc(100vh - 113px); */\n  height: calc((var(--vh, 1vh) * 100) - 113px);\n  overflow-y: auto;\n}\n\n.search-title-box {\n  background-color: #f2f2f2;\n  min-width: 110px;\n  border-bottom: 1px solid #fff;\n  border-right: 6px solid #fff;\n  /* padding: 13px 11px; */\n  padding: 0.25rem 11px;\n}\n\n.search-sub-bottom-border {\n  border-bottom: 1px solid #fff;\n  /* padding-right: 11px; */\n  min-height: 38px;\n}\n\n.search-reset-text {\n  text-align: center;\n}\n\n.sub-title {\n  font-size: 13px;\n  margin-left: 10px;\n}\n\n.sub-title.hover-help:hover {\n  cursor: help;\n}\n\n.sfs-9px {\n  font-size: 9px;\n}\n\n.search-sub-title-box {\n  min-width: 110px;\n  border-right: 6px solid #fff;\n  background-color: #f2f2f2;\n  padding-left: 11px;\n  padding-right: 11px;\n}\n\n.search-content-box {\n  background-color: #f2f2f2;\n  padding-right: 8px;\n  padding-left: 8px;\n  padding: 0.5rem 8px;\n  /* border-bottom: 1px solid #fff; */\n}\n\n.search-content-border-box {\n  border-bottom: 1px solid #fff;\n}\n\n.search-input {\n  outline: none;\n  max-width: 489px;\n  width: 489px;\n  height: 32px;\n}\n\n.search-check-label {\n  background-color: #fff;\n  width: 13px;\n  height: 13px;\n}\n\n.search-checkbox:checked + .search-check-label {\n  background: url(../../../public/image/icon/check.svg) #fff no-repeat center / contain;\n}\n\n.search-btn {\n  background-color: #971b4d;\n  width: 157px;\n  height: 38px;\n  border-radius: 5px;\n  text-align: center;\n  font-size: 17px;\n  line-height: 38px;\n}\n\n.search-flex-box {\n  display: flex;\n  align-items: stretch;\n  overflow-x: hidden;\n}\n\n.search-title-text {\n  text-align: center;\n  font-size: 16px;\n}\n\n.search-input-text {\n  font-size: 16px;\n}\n\n.search-input-text::placeholder {\n  color: #ababab;\n}\n\n.result-container {\n  padding-bottom: 1px;\n  /* margin-top: 44px; */\n}\n\n.result-content {\n  background-color: #f2f2f2;\n  /* height: 96px; */\n  padding: 10px 6.5px 10px 8.5px;\n}\n\n.result-title-text {\n  font-size: 17.5px;\n}\n\n.result-title-flex {\n  /* margin-bottom: 8px; */\n}\n\n.result-sub-text {\n  font-size: 10px;\n}\n\n.result-sub-type-text {\n  margin-bottom: 13px;\n}\n\n.result-sub-type2-text {\n  margin-bottom: 2px;\n}\n\n.result-price-text {\n  font-size: 15px;\n  /* margin-top: 5px; */\n}\n\n.result-box:hover .result-content {\n  background-color: #fff2e9;\n}\n\n.result-img {\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.result-box:hover .result-img img {\n  width: 110%;\n  height: 110%;\n}\n\n.result-img img {\n  transition: all 0.5s ease-in-out;\n}\n\n.result-img {\n  aspect-ratio: 5 / 3;\n  /* height: 191px; */\n  background-color: rgb(164, 164, 164);\n}\n\n.result-img img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.result-icon {\n  width: 28px;\n  height: 28px;\n}\n\n.search-title-content {\n  margin-bottom: 20px;\n}\n\n.search-result-category {\n  padding-bottom: 19px;\n}\n\n.search-item2-title {\n  font-size: 22.5px;\n  padding-bottom: 5px;\n}\n\n.search-item3-title {\n  font-size: 19px;\n  padding-bottom: 3px;\n}\n\n.sticky-title {\n  position: sticky;\n  top: 0;\n  background-color: #fff;\n  z-index: 888;\n  padding-top: 11px;\n}\n\n.sticky-item2 {\n  position: sticky;\n  top: 70.25px;\n  background-color: #fff;\n  z-index: 887;\n}\n\n.sticky-item3 {\n  position: sticky;\n  top: 108px;\n  background-color: #fff;\n  z-index: 886;\n}\n\n.sticky-item4 {\n  position: sticky;\n  top: 138.5px;\n  background-color: #fff;\n  z-index: 885;\n  padding-bottom: 5px;\n}\n\n.no-search {\n  margin-top: 44px;\n  text-align: center;\n}\n\n.result-price-flex-box {\n  align-items: center;\n}\n\n.search-favor-title {\n  border-bottom: 0;\n}\n\n.search-last-border,\n.search-last-content-border {\n  border-bottom: 0;\n}\n\n.search-favor-box {\n  border-top: 4px solid #fff;\n}\n\n.pop-container {\n  /* position: relative; */\n}\n\n.search-pop {\n  position: absolute;\n  z-index: 889;\n  padding: 15px 12px;\n  background-color: #fff;\n  border: 1px solid #971b4d;\n  max-width: 250px;\n}\n\n.pop-title {\n  font-size: 11px;\n  color: #282828;\n  font-weight: 700;\n}\n\n.pop-box {\n  margin-top: 8px;\n  gap: 0 8px;\n}\n\n.pop-box-img {\n  width: 100%;\n  /* height: 73px; */\n}\n\n.pop-content {\n  font-size: 9px;\n  color: #787878;\n  white-space: pre-wrap;\n  margin-top: 8px;\n}\n\n.search-label-width {\n  width: 130px;\n}\n\n@media (max-width: 1478px) {\n  .search-label-width {\n    width: 105px;\n  }\n\n  .search-label-width .sub-title {\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 1300px) {\n  .search-box {\n    padding-left: 0;\n    margin-left: 0;\n    background-color: #fff;\n  }\n\n  .search-bg-box {\n    /* padding-bottom: 120px; */\n  }\n\n  .search-container {\n    width: 100%;\n  }\n\n  .search-flex-box {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .search-title-box {\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n\n  .search-favor-title {\n    border-bottom: 1px solid white;\n  }\n\n  .search-title-box,\n  .search-sub-title-box {\n    width: 100%;\n    border-right: 0;\n  }\n\n  .search-sub-title-box {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .search-content-box {\n    flex-wrap: wrap;\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n\n  .search-title-text {\n    text-align: start;\n    /* margin-left: 1rem; */\n  }\n\n  .search-name-text {\n    margin-left: 0;\n  }\n\n  .result-container {\n    /* padding-bottom: 150px; */\n  }\n\n  .search-last-border {\n    border-bottom: 1px solid #fff;\n  }\n}\n\n@media (max-width: 768px) {\n  .pop-title {\n    font-size: 12px;\n  }\n\n  .search-reset-text {\n    text-align: start;\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n\n  .search-bg-box {\n    padding-top: 0;\n  }\n\n  .result-price-flex-box {\n    align-items: end;\n  }\n\n  .result-sub-type2-text {\n    margin-bottom: 0;\n  }\n\n  .search-input-text {\n    font-size: 14px;\n  }\n\n  .search-input {\n    width: 100%;\n    max-width: initial;\n  }\n\n  .result-box:nth-child(even) {\n    padding-left: 2.5px;\n  }\n\n  .result-box:nth-child(odd) {\n    padding-right: 2.5px;\n  }\n\n  .sticky-title {\n    padding-top: 13px;\n  }\n\n  .sticky-item2 {\n    top: 48.5px;\n  }\n\n  .sticky-item3 {\n    top: 69px;\n  }\n\n  .sticky-item4 {\n    top: 91.5px;\n  }\n\n  .search-container {\n    height: calc(100vh - 163.09px);\n    overflow-y: auto;\n  }\n\n  .search-box {\n    padding-top: 10px;\n  }\n\n  .search-full-box {\n    padding: 17px 12px 17px 13px;\n  }\n\n  .search-sticky-title-box {\n    padding: 12px 12px 8px 13px;\n  }\n\n  .search-title {\n    font-size: 19.753px;\n  }\n\n  .search-title-icon {\n    width: 25px;\n    height: 25px;\n    margin-right: 5px;\n  }\n\n  .search-title-content {\n    margin-bottom: 15px;\n  }\n\n  .search-title-text {\n    font-size: 14px;\n  }\n\n  .sub-title {\n    font-size: 10px;\n    margin-left: 5px;\n  }\n\n  .search-btn {\n    font-size: 15px;\n  }\n\n  .search-result-category {\n    padding-bottom: 7px;\n  }\n\n  .search-item2-title {\n    font-size: 11.358px;\n    padding-bottom: 5px;\n  }\n\n  .search-item3-title {\n    font-size: 11.358px;\n    padding-bottom: 6px;\n  }\n\n  .result-img {\n    /* height: 101px; */\n  }\n\n  .result-content {\n    padding: 6px 5px 5px 5px;\n    height: auto;\n  }\n\n  .result-title-text {\n    font-size: 13px;\n  }\n\n  .result-title-flex {\n    margin-bottom: 0;\n  }\n\n  .result-sub-text {\n    font-size: 8px;\n  }\n\n  .result-sub-type-text {\n    margin-bottom: 0;\n  }\n\n  .result-price-text {\n    font-size: 10px;\n    margin-top: 0;\n  }\n\n  .result-icon {\n    width: 20px;\n    height: 20px;\n  }\n\n  .search-label-width {\n    width: 95px;\n  }\n\n  .search-sub-bottom-border {\n    min-height: auto;\n    padding-top: 10px;\n  }\n\n  .search-title-box {\n    padding-bottom: 0;\n    padding-top: 1rem;\n  }\n\n  .search-content-box {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n\n  .result-price-mobile-text {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 1280px) {\n  .search-container {\n    height: calc(100vh - 129.09px);\n  }\n}\n\nbody {\n  -ms-overflow-style: none;\n}\n\nbody::-webkit-scrollbar {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
